import styled from 'styled-components'

export const TimeLineContainer = styled.div`
  height: 100%;
  overflow-y: scroll;
`

export const TimeLineTitle = styled.label`
  display: flex;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 24px;

  color: ${({ theme }) => theme.ds.colors.neutral700};
  font-size: ${({ theme }) => theme.ds.typography.size.medium};
  font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
  line-height: 28px;
`

export const TimeLineItem = styled.div<any>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 20px;
  background: ${({ theme, selected }) => selected && theme.ds.colors.primary25};
  cursor: pointer;
`

export const InfoWrapper = styled.div`
  display: block;
  align-items: center;
  gap: 4px;

  p {
    font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
    color: ${({ theme }) => theme.ds.colors.neutral900};
  }

  strong {
    color: ${({ theme }) => theme.ds.colors.neutral700};
    font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
    font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
  }

  span {
    font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
    color: ${({ theme }) => theme.ds.colors.primary900};
    font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
    font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
  }
`

export const PointerContainer = styled.div`
  margin-left: auto;
`
